$(document).ready(function(){
	if($(".repaymentTable").length > 0){
		var json = JSON.parse(sessionStorage.getItem('ammortamento'));
		if(json == null || json == undefined){
			json = JSON.parse(JSON.stringify(window.pianoAmmortamento));
		}
		var genericSettings = {};
		var settings = $("#genericSettings");
        if (settings.length > 0) {
            genericSettings = JSON.parse(settings.val());
        }
		var currentSelectedUniversalCase = sessionStorage.getItem("currentSelectedUniversalCase");
		var pianoTopPage = JSON.parse(sessionStorage.getItem('pianoTopPage'));
		
		if(pianoTopPage != null && pianoTopPage != undefined){
			var rows = $(".element-row."+currentSelectedUniversalCase.replace("-", "_")+".right");
//			var containerRow = rows.parent();
			rows.html('');
			$.each(pianoTopPage, function(key, value){
				for(i = 0; i < value.length; i++){
//					var cloned = row.clone();
//					cloned.attr("style", 'display: block');
//					cloned.addClass("visibile-row")
//					cloned.html("<span>"+value[i]+"</span>");
//					containerRow.append(cloned);
					$(rows[i]).attr("style", 'display: block');
					$(rows[i]).addClass("visibile-row")
					$(rows[i]).html("<span>"+value[i]+"</span>");
				}
			});
			$(".element-row."+currentSelectedUniversalCase.replace("-", "_")+".head").attr("style", 'display: block');
		}
		
		if(json != null && json != undefined){
			var table = $("#tbl2_table-repayment");
			var clonedTable = table.clone();
			var columnsList = table.find("ul.tbl2__highlist");
			var columnsRow = columnsList.find("li.tbl2__highlistItem");
			var columnsRowList = columnsRow.find("ul.tbl__highlist");
			var columns = columnsRowList.find("li.tbl__highlistItem");
			var head = table.find("ul.tbl__highlist."+currentSelectedUniversalCase);
			var totalColumns = head.find(".tbl__highlistItem").length;
		    console.log(totalColumns);
		    columnsRowList.html("");
		    columnsList.html("");
			$.each(json, function(key, value){
				 var clonedRow = columnsRow.clone();
				 var columnsRowListCloned = columnsRowList.clone();
				 for(i = 0; i <value.length; i++){
					var cloned = columns.clone();
					var convertedValue = 0;
					if(currentSelectedUniversalCase == 'eur-fixed'){
						
						convertedValue = value[3].split(" ")[0].toString().replace(",",".") * value[4].split(" ")[0].toString().replace(",",".");
						convertedValue = number_format(parseFloat(convertedValue), 2, genericSettings.decimal, genericSettings.separator) + " RSD";
					
					} else if (currentSelectedUniversalCase == "eur-variable"){
						
						convertedValue = value[4].split(" ")[0].toString().replace(",",".") * value[6].split(" ")[0].toString().replace(",",".");
						convertedValue = number_format(parseFloat(convertedValue), 2, genericSettings.decimal, genericSettings.separator) + " RSD";

					}
					if(currentSelectedUniversalCase == 'eur-fixed' && i == 4){
						
		   		    	cloned.html('<span class="tbl__highlistLabel"></span><span class="tbl__highlistValue"><strong>'+convertedValue+'</strong></span>');

					} else if(currentSelectedUniversalCase == 'eur-variable' && i == 6){
						
		   		    	cloned.html('<span class="tbl__highlistLabel"></span><span class="tbl__highlistValue"><strong>'+convertedValue+'</strong></span>');
					
					} else {
						
						cloned.html('<span class="tbl__highlistLabel"></span><span class="tbl__highlistValue"><strong>'+value[i]+'</strong></span>');
					}	   		    	
	   		    	columnsRowListCloned.append(cloned);
				 }
   		    	clonedRow.append(columnsRowListCloned);
	   		    columnsList.append(clonedRow);

			});
			$('.'+currentSelectedUniversalCase).attr("style", "display: flex");
		}
	}
})